import wretch from 'wretch';
import { startApp } from '@quintype/framework/client/start';
import 'intersection-observer';

import { renderApplication, preRenderApplication } from './render';
import CUSTOM_REDUCERS from '../store/reducers';

import '../../app/assets/stylesheets/app.scss';
import { getStaticConfig } from '../isomorphic/helpers/utils';

function enableHotReload(store) {
  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./render', () => {
      preRenderApplication(store);
      renderApplication(store);
    });
  }
}

global.wretch = wretch;

startApp(renderApplication, CUSTOM_REDUCERS, {
  enableServiceWorker: process.env.NODE_ENV === 'production',
  appVersion: require('../isomorphic/app-version'),
  preRenderApplication,
}).then(enableHotReload);

if (typeof window !== "undefined") {
  // Only import and initialize Bugfender in the browser
  const { Bugfender } = require('@bugfender/sdk');
  const appKey = getStaticConfig(['features', 'analytics', 'bugFender_appKey']);
  if (appKey) {
    Bugfender.init({
      appKey,
      // overrideConsoleMethods: true,
      // printToConsole: true,
    });
  } else {
    console.warn("Bugfender appKey not found in config.");
  }
}
